import _ from 'lodash';
import translations from './translations';

const t = (lang, transKey) => _.get(translations, `[${transKey}][${lang}]`);

export default t;



// WEBPACK FOOTER //
// ./src/translations/getTranslation.js